<template>
  <el-dialog
    :visible="visible"
    width="460px"
    :close-on-click-modal="true"
    :show-close="false"
    title="系统登录"
    center
    @close="handleClose"
  >
    <el-form
      :hide-required-asterisk="true"
      :model="loginForm"
      :rules="rules"
      ref="loginForm"
      label-width="60px"
      @keyup.enter.native="handleLogin"
    >
      <el-form-item
        label="用户名"
        prop="username"
      >
        <el-input
          v-model="loginForm.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="密码"
        prop="password"
      >
        <el-input
          v-model="loginForm.password"
          type="password"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
    </el-form>
    <div
      class="login-error"
      v-if="errorMessage"
    >{{ errorMessage }}</div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        style="width: 200px"
        @click="handleLogin"
        :loading="loading"
      >登录</el-button>
      <div
        class="additional-actions"
        v-if="false"
      >
        <span class="forgot-password-link">忘记密码</span>
        <span class="reset-password-link">授权重置密码</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { login } from '@/api/base';
// import store from '@/store';
import EventBus from '@/lib/events';

export default {
  name: 'LoginModal',
  data() {
    return {
      visible: true,
      loginForm: {
        username: '',
        password: '',
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      loading: false,
      errorMessage: '',
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.errorMessage = '';

          try {
            const response = await login(
              {
                username: this.loginForm.username,
                password: this.loginForm.password,
              },
              true
            );

            // Store token in Vuex or localStorage
            // store.dispatch('user/setAccessToken', response.access_token);
            // store.dispatch('user/setUser', {});

            EventBus.$emit('login-success', response);

            this.$message.success('登录成功');
            this.handleClose();
          } catch (error) {
            console.error('Login error:', error);
            this.errorMessage = error.response?.message || '登录失败.请重试.';
          } finally {
            this.loading = false;
          }
        }
      });
    },
    handleClose() {
      this.$refs.loginForm.resetFields();
      this.errorMessage = '';
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-error {
  color: #f56c6c;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.forgot-password {
  text-align: right;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
}

.register-link {
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
}

.register-link span {
  color: #409eff;
  cursor: pointer;
}

.dialog-footer {
  margin-top: -20px;
  text-align: center;
}

.additional-actions {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.additional-actions span {
  color: #909399;
  cursor: pointer;
  font-size: 14px;

  &:not(:last-child) {
    position: relative;
    padding-right: 10px;
    margin-right: 10px;

    &::after {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      content: ' ';
      width: 1px;
      height: 14px;
      background-color: #909399;
    }
  }
}
</style>
